import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Myplugin from './plugins/myplugin'
import '@/css/element-variables.scss'
import '@/css/main.scss'
import echarts from 'echarts'
import '@/icons'
import './permission'
import vPermission from './directives/permission'
import fly from '@/utils/request'
import * as utils from './utils/index'
import * as config from './utils/config'

Vue.use(Myplugin)
Vue.directive('permission', vPermission)
Vue.prototype.$echarts = echarts
Vue.prototype.isProduction = window.location.host.indexOf('eyeqme.com.cn') > -1
Vue.config.productionTip = false
Vue.prototype.$utils = utils
Vue.prototype.$config = config
Vue.prototype.$fly = fly

Vue.use(ElementUI, { size: 'small', zIndex: 3000 })

//页面跳转滚动条归零
router.afterEach(() => {
  window.scrollTo(0, 0);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
